module.exports = __webpack_public_path__ + "img/pt.42a6e5f6.jpg";